<template>
  <div class="chineseDrink column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div class="width180">
          <el-input placeholder="药品编码" style="width: 100%;" clearable v-model="code"></el-input>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="药品名称" style="width: 100%;" clearable v-model="name"></el-input>
        </div>
        <div class="width130 margin-left10">
          <el-select v-model="selectStoreHouse" placeholder="选择库房" style="width: 100%;" filterable clearable>
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width130 margin-left10">
          <el-select v-model="selectStatus" placeholder="选择状态" style="width: 100%;" filterable clearable>
            <el-option v-for="item in [{id:0,name:'下架'},{id:1,name:'上架'}]" :key="item.id" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">清空</div>
        <div class="flex1"></div>
        <div class="btn-blank width200 btn-height40 margin-left10" @click="clickPrice1" v-if="canOperate">
          批量修改常规零售价
        </div>
        <div class="btn-blank width200 btn-height40 margin-left10" @click="clickPrice2" v-if="canOperate">
          批量修改颗粒零售价
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickUp" v-if="canOperate">批量上架</div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickDown" v-if="canOperate">批量下架</div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickImport" v-if="canOperate">导入</div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickExport">导出</div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickAdd" v-if="canOperate">新增</div>
      </div>
      <div class="column-me flex1 margin-top20">
        <div>
          <el-table :data="tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style" @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center" width="50"></el-table-column>
            <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
            <el-table-column prop="sn" label="药品编码" align="center" width="120"></el-table-column>
            <el-table-column prop="name" label="药品名称" align="center" width="150"></el-table-column>
            <el-table-column prop="spec" label="品质规格" align="center" width="120"></el-table-column>
            <el-table-column prop="packageSpec" label="包装规格" align="center" width="120"></el-table-column>
            <el-table-column prop="productAddress" label="产地" align="center" width="150"></el-table-column>
            <el-table-column label="常规剂型零售价" align="center" width="200">
              <template v-slot="scope">
                <div class="row-me center-all" v-if="!canOperate">
                  {{ scope.row.normalPrice }}
                </div>
                <div v-else>
                  <div class="row-me center-all" v-if="scope.row.showEditPrice1">
                    <div class="width80">
                      <el-input style="width: 100%;" v-model="scope.row.normalPrice"
                                @input="()=>{scope.row.normalPrice = $method.checkInput(scope.row.normalPrice,3)}">
                      </el-input>
                    </div>
                    <img src="../../assets/img/ok.png" class="img-table pointer"
                         @click="clickPrice1Ok(scope.row)">
                    <img src="../../assets/img/cancel.png" class="img-table pointer"
                         @click="clickPrice1Cancel(scope.row)">
                  </div>
                  <div class="row-me center-all pointer" v-else @click="scope.row.showEditPrice1=true">
                    <div class="flex1 align-right margin-right10">{{ scope.row.normalPrice }}</div>
                    <img src="../../assets/img/edit.png" class="img-table pointer margin-right20">
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="颗粒剂型零售价" align="center" width="200">
              <template v-slot="scope">
                <div class="row-me center-all" v-if="!canOperate">
                  {{ scope.row.normalPrice }}
                </div>
                <div v-else>
                  <div class="row-me center-all" v-if="scope.row.showEditPrice2">
                    <div class="width80">
                      <el-input style="width: 100%;" v-model="scope.row.granulePrice"
                                @input="()=>{scope.row.granulePrice = this.$method.checkInput(scope.row.granulePrice,3)}">
                      </el-input>
                    </div>
                    <img src="../../assets/img/ok.png" class="img-table pointer"
                         @click="clickPrice2Ok(scope.row)">
                    <img src="../../assets/img/cancel.png" class="img-table pointer"
                         @click="clickPrice2Cancel(scope.row)">
                  </div>
                  <div class="row-me center-all" v-else @click="scope.row.showEditPrice2=true">
                    <div class="flex1 align-right margin-right10">{{ scope.row.granulePrice }}</div>
                    <img src="../../assets/img/edit.png" class="img-table pointer margin-right20">
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="earlyNum" label="预警数量" align="center" width="120"></el-table-column>
            <el-table-column prop="pharmacyName" label="所在库房" align="center" width="150"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="状态" align="center">
              <template #default='scope'>
                <div>{{ scope.row.status === 1 ? '上架' : '下架' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="220" fixed="right" v-if="canOperate">
              <template v-slot="scope">
                <div class="row-me center-all">
                  <div class="blue-text" @click="clickEdit(scope.row)">修改</div>
                  <div class="blue-text margin-left30" @click="clickUpTable(scope.row)" v-if="scope.row.status===0">
                    上架
                  </div>
                  <div class="blue-text margin-left30" @click="clickDownTable(scope.row)" v-if="scope.row.status===1">
                    下架
                  </div>
                  <div class="blue-text margin-left30" @click="clickDelete(scope.row)">删除</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="margin-top20">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增药品 -->
    <el-dialog :title="drugTitle" v-model="visibleDrug" :width="selectItem.id?'80%':'60%'" top="5vh"
               :destroy-on-close="true">
      <editDrug :id="selectItem.id"></editDrug>
    </el-dialog>
    <!-- 批量修改常规批发价（批量修改颗粒批发价） -->
    <el-dialog :title="drugPriceTitle" v-model="visibleDrugPrice" width="40%" top="10vh" :destroy-on-close="true">
      <div class="padding20">
        <div class="row-me row-center">
          <div><span class="red-star">*</span>修改方式：</div>
          <el-radio-group v-model="selectWay">
            <el-radio :label="1">按比例</el-radio>
            <el-radio :label="2">按固额</el-radio>
          </el-radio-group>
        </div>
        <div class="row-me row-center margin-top30" v-if="selectWay===1">
          <div><span class="red-star">*</span>按比例：</div>
          <div class="width200">
            <el-input placeholder="请输入" style="width: 100%;" v-model="rate" type="number" min="0"
                      @input="rate=$method.checkInput(rate,3)"
                      :class="{'red-border':showRedBorder&&$method.isEmpty(rate)}">
            </el-input>
          </div>
          <div class="margin-left10 margin-right30">%</div>
          <el-radio-group v-model="rateRadio">
            <el-radio :label="true">上浮</el-radio>
            <el-radio :label="false">下降</el-radio>
          </el-radio-group>
        </div>
        <div class="row-me row-center margin-top30" v-if="selectWay===2">
          <div><span class="red-star">*</span>按固额：</div>
          <div class="width300">
            <el-input placeholder="请输入" style="width: 100%;" v-model="money" type="number" min="0"
                      @input="money=$method.checkInput(money,3)"
                      :class="{'red-border':showRedBorder&&$method.isEmpty(money)}"></el-input>
          </div>
          <div class="margin-left10 margin-right30">元</div>
        </div>
        <div class="row-me row-center flex-end1 margin-top200">
          <div class="btn-blank width140 btn-height40" @click="clickCancel">取消</div>
          <div class="btn-blue width140 btn-height40 margin-left20" @click="clickSave">保存</div>
        </div>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <el-dialog title="导入" v-model="visibleImport" width="40%" top="10vh" :destroy-on-close="true">
      <importExcel name='中药饮片导入模板' :downloadUrl="downloadUrl" :requestUrl="requestUrl"></importExcel>
    </el-dialog>
  </div>
</template>

<script>
import editDrug from './editDrug.vue'
import importExcel from '../../components/import/importExcel.vue'

export default {
  components: {
    editDrug,
    importExcel
  },
  data() {
    return {
      code: '',
      name: '',
      selectStoreHouse: '',
      selectStatus: '',
      tableData: [],
      multipleSelection: [], //多选药品
      pageNo: 1,
      total: 0,
      visibleDrug: false,
      visibleDrugPrice: false,
      target: '', //1 常规价 2 颗粒剂
      selectWay: 1, //1按比例 2按固额
      rate: '',
      rateRadio: true,
      money: '',
      drugPriceTitle: '',
      drugTitle: '',
      showRedBorder: false,
      visibleImport: false,
      downloadUrl: '', //导入模板下载链接
      requestUrl: '', //导入接口
      houseArray: [], //库房列表
      selectItem: {}, //选中的药品
      canOperate: false,//是否可操作
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getHouseList()
    this.pageNo = 1
    this.getData()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //新增
    clickAdd() {
      this.drugTitle = '新增药品'
      this.selectItem = {}
      this.visibleDrug = true
      this.bus.$off('drugAddSuccess')
      this.bus.$on('drugAddSuccess', res => {
        this.visibleDrug = false
        this.pageNo = 1
        this.getData()
      })
    },
    //修改
    clickEdit(item) {
      this.drugTitle = '药品信息'
      this.selectItem = this.$method.deepClone(item)
      this.visibleDrug = true
      this.bus.$off('drugAddSuccess')
      this.bus.$on('drugAddSuccess', res => {
        this.visibleDrug = false
        this.getData()
      })
    },
    //下架
    clickDownTable(item) {
      this.$confirm("您确定要下架【" + item.name + "】吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        item.status = 0
        this.$postRequest('/admin/drug/update', item).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //上架
    clickUpTable(item) {
      this.$confirm("您确定要上架【" + item.name + "】吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        item.status = 1
        this.$postRequest('/admin/drug/update', item).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //刪除
    clickDelete(item) {
      this.$confirm("您确定要删除【" + item.name + "】吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/drug/delete', [item.id]).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.pageNo = 1
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //表格选择
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //批量修改常规批发价
    clickPrice1() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择药品')
        return
      }
      this.target = 1
      this.selectWay = 1
      this.rate = ''
      this.rateRadio = true
      this.money = ''
      this.drugPriceTitle = '批量修改常规零售价'
      this.showRedBorder = false
      this.visibleDrugPrice = true
    },
    //批量修改颗粒批发价
    clickPrice2() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择药品')
        return
      }
      this.target = 2
      this.selectWay = 1
      this.rate = ''
      this.rateRadio = true
      this.money = ''
      this.drugPriceTitle = '批量修改颗粒零售价'
      this.showRedBorder = false
      this.visibleDrugPrice = true
    },
    //批量上架
    clickUp() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择药品')
        return
      }
      let ids = []
      for (let item of this.multipleSelection) {
        ids.push(item.id)
      }
      this.$confirm("您确定要批量上架吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/drug/online/1', ids).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.multipleSelection = []
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //批量下架
    clickDown() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择药品')
        return
      }
      let ids = []
      for (let item of this.multipleSelection) {
        ids.push(item.id)
      }
      this.$confirm("您确定要批量下架吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/drug/online/0', ids).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.multipleSelection = []
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //导入
    clickImport() {
      this.downloadUrl = this.$axios.defaults.baseURL + '/template/药品导入模板.xlsx'
      this.requestUrl = '/admin/drug/import'
      this.visibleImport = true
      this.bus.$off('importSuccess')
      this.bus.$on('importSuccess', res => {
        this.visibleImport = false
        if (res === 'refresh') {
          this.pageNo = 1
          this.getData()
        }
      })
    },
    //导出
    clickExport() {
      let token = sessionStorage.getItem('token')
      let param = {
        name: this.name,
        pharmacyId: this.selectStoreHouse,
        status: this.selectStatus,
        pageNumber: this.pageNo,
        token: token,
      }
      let url = this.$baseUrl + '/admin/drug/drugExport?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //保存
    clickSave() {
      if ((this.selectWay === 1 && this.$method.isEmpty(this.rate)) || (this.selectWay === 2 && this.$method.isEmpty(this.money))) {
        this.showRedBorder = true
        return
      }
      let ids = []
      for (let item of this.multipleSelection) {
        ids.push(item.id)
      }
      let param;
      if (this.selectWay === 1) { //按比例
        param = {
          target: this.target,
          type: this.selectWay,
          price: this.rate,
          add: this.rateRadio,
        }
      } else if (this.selectWay === 2) { //按固额
        param = {
          target: this.target,
          type: this.selectWay,
          price: this.money,
        }
      }
      param.ids = ids
      this.$postRequest('/admin/drug/updatePrice', param).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visibleDrugPrice = false
          this.multipleSelection = []
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //取消
    clickCancel() {
      this.visibleDrugPrice = false
    },
    //查询
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      this.name = ''
      this.selectStoreHouse = ''
      this.selectStatus = ''
      this.pageNo = 1
      this.getData()
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //修改价格
    clickPrice1Ok(item) {
      this.$postRequest('/admin/drug/update', item).then((res) => {
        if (res) {
          this.$message.success(res.message)
          item.showEditPrice1 = false
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //取消修改价格
    clickPrice1Cancel(item) {
      item.normalPrice = item.normalPrice1
      item.showEditPrice1 = false
    },
    //修改价格
    clickPrice2Ok(item) {
      this.$postRequest('/admin/drug/update', item).then((res) => {
        if (res) {
          this.$message.success(res.message)
          item.showEditPrice2 = false
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //取消修改价格
    clickPrice2Cancel(item) {
      item.granulePrice = item.granulePrice1
      item.showEditPrice2 = false
    },
    //获取库房列表
    getHouseList() {
      this.$getRequest('/admin/pharmacy/listAll', {}).then((res) => {
        if (res) {
          this.houseArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取药品列表
    getData() {
      this.$getRequest('/admin/drug/page', {
        sn: this.code,
        name: this.name,
        pharmacyId: this.selectStoreHouse,
        status: this.selectStatus,
        pageNumber: this.pageNo,
        type: 0, //药品类型 0中药 1 中医外治
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          for (var i = 0; i < res.data.list.length; i++) {
            let item = res.data.list[i]
            item.normalPrice1 = item.normalPrice
            item.granulePrice1 = item.granulePrice
          }
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.chineseDrink {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;

    .img-table {
      height: 20px;
      object-fit: scale-down;
      margin-left: 10px;
    }
  }
}
</style>
